import Icon from "@/components/units/Icon"
import PropTypes from 'prop-types'

const props = {
  icon: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  onDismiss: PropTypes.func,
}

export default function Notification ({icon, title,message}){
  // TODO: Add onDismiss Handler
  return (
    <div className="tw-p-4 tw-flex tw-gap-4 tw-items-start tw-bg-white tw-rounded-2xl">
      {
        icon && (
          <Icon
              iconName={icon}
              wrapperStyle="tw-w-5 tw-h-5 tw-p-2 tw-box-content hover:tw-bg-[#75F7FF44] tw-rounded-md"
          />
        )
      }
      <div className="tw-text-xl">
        {
          title && (
            <p>{title}</p>
          )
        }
        {
          message && (
            <p>{message}</p>
          )
        }
      </div>
    </div>
  )
}
Notification.propTypes = props
